import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Sri Lankan National ID generator following Single Responsibility Principle
 */
export class LkGenerator extends BaseGenerator {
  generate(options = {}) {
    const { format = 'old' } = options; // 'old' or 'new'

    if (format === 'old') {
      // Old format: 9 digits + V/X
      const digits = this.randomDigits(9);
      const checkChar = this.randomInt(0, 1) ? 'V' : 'X';
      return digits + checkChar;
    } else {
      // New format: 12 digits (YYYYDDDNNNNN)
      const year = this.randomInt(1900, 2100);
      const dayOfYear = this.padZero(this.randomInt(1, 366), 3);
      const sequence = this.randomDigits(5);
      return year + dayOfYear + sequence;
    }
  }
}